<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>Sjan & Raisoni Achievers Award</h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm sjan-award section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2>Sjan & Raisoni Achievers <span> Award</span></h2>
            <p>SJAN, Raisoni Group of Institutions started this Raisoni Achiever’s Award in Collaboration with <br>The
                Sports Journalists' Association of Nagpur</p>
        </div>
        <div class="row">
            <div class="col-md-8">
                <div class="widget_title inner-title mt-3">
                    <h4>RAISONI ACHIEVER’S AWARD IN COLLABORATION</h4>
                </div>
                <p>SJAN, Raisoni Group of Institutions started this Raisoni Achiever’s Award in Collaboration with The
                    Sports Journalists' Association of Nagpur. It serves as a time appreciators of sports joined
                    together to celebrate the best sporting achievements from the previous calendar year and it is Named
                    as GH Raisoni SJAN Achievers Awards..</p>


                <div class="fide-chess-text">
                    <p>Since last five years GHR Sports and Cultural foundation organizing achievement in sports awards
                        in association with SJAN. This association is encouraging the sports person to perform in their
                        fields and personal life.<br>
                        Directly or indirectly we all are associated to the sports in various roles.</p>
                </div>
            </div>

            <div class="col-md-4">
                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sjan.webp" class="w-100"
                    alt="GHRSCF">
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <p>Sometimes, it's just a simple game, when we see it on our TV sets and in ground. But often, a sport
                    is much more than that. It's full of life lessons. It can teach you about failure, joy and
                    disappointment, excitement, winning and losing. It is not only about sportsman spirit but about
                    maturity, teamwork, humility and selflessness.</p>
            </div>

            <p>Now GHRSCF takes the pride that sports person waits for this event and prepare themselves to get
                nominated for the awards. Foundation is hopeful and quite sure that in coming years, this event will be
                recognized on National level and we will be getting prepared for it.</p>
            <p>G H Raisoni sports and cultural foundation is dedicated for the encouragement and enhancement of sports.
                We wish, our sports person should get recognized on National and International levels. Giving this award
                is just one brick towards your Everest of success. Facing challenges of sports teaches us to tackle with
                other challenges of the life as well as survive in a competitive society.</p>
            <p>Someone said very correct, “It is all in mind”. If you decide Everest will also bow down to you. This
                award is a small initiative to recognize the talents, but we aim to see them achieving best in their
                life in spite whatever the hurdles they come across. GHR Sports & Cultural Foundation will continue to
                encourage and enhance the culture of sports and various activities.</p>

            <div _ngcontent-dhg-c30="" class="border-line-sm"></div>

            <div class="widget_title inner-title mt-3">
                <h4>SJAN-Raisoni Achievers Awards 2024</h4>
            </div>
            <p class="text-justify">Every sports person's career has its ups and downs. It is necessary for the
                players to work tirelessly and seize the opportunity to prove themselves, said
                former international badminton player and Dutch Open champion Ajay
                Jayaram.</p>


            <p class="text-justify">He was speaking during SJAN- Raisoni Achievers annual sports award
                distribution programme organized by Sports Journalists Association of
                Nagpur (SJAN) in association with Raisoni Group at Chitnavis Centre, Civil
                Lines here on Saturday.<br>
                Director of Global Education Limited Aditya Bhandari, Baidyanath director
                Siddhesh Sharma, noted sports organizer Deven Dasture and SJAN president
                Dr. Ram Thakur shared the dais.</p>
            <p class="text-justify">Speaking further Ajay Jayaram said, every sports person has to face many
                difficulties right from sustaining an injury. But in such an adverse situation, the
                players should not get disappointed and think how to overcome those
                difficulties. On this occasion, Jayaram shared his own experiences regarding
                the injury he suffered in his career and his subsequent comeback. On this
                occasion, dignitaries present on the dais expressed their views.
                International archer Ojas Deotale, Indian cricketer Jitesh Sharma and
                international badminton player Ritika Thaker were honored in the senior
                group. Under-19 cricketer Sanyog Bhagwat and basketball player Sameeksha
                Chandak were honored in the junior category Apart from this, Maharashtra
                State Table Tennis Association secretary Adv. Ashutosh Potnis was awarded
                the best organizer trophy. St. Ursula High School and Yashwantrao Chavan
                College of Engineering (YCCE) were awarded as best school and college
                respectively. Ojas Deotale's award was accepted by his mother Archana and
                father Pravin Deotale. The programme was moderated by Naresh Shelke and
                Dr. Ram Thakur.</p>


            <p class="text-justify">Project director of GH Raisoni Sports and Cultural Foundation, Dr Mrinalini
                Naik, Raisoni group PRO Amit Gandhare, former deputy director of sports Dr
                Jaiprakash Duble, Naval Meshram and sports organizers were also present
                on the occasion.</p>
            <p class="text-justify">Confidence grows with hard work: Jitesh</p>
            <p class="text-justify">According to Indian wicketkeeper Jitesh Sharma it doesn&#39;t matter where you
                come from or what you do in the field of sports. If you are willing to work hard,
                it will work for you in the actual field. Only hard work increases the confidence
                of players.</p>
            <p class="text-justify">He further said although the game of cricket gets maximum media attention
                and publicity I personally like those sportspersons who make their mark in the
                individual events. In team sports, other players also help us but in individual
                sports a player has to plan and perform accordingly. Therefore the future of
                such sportspersons who play individual games is bright.</p>
            <ul class="list-style list-style1">
                <li> Ojas Deotale – (International archer-senior group)</li>
                <li> Jitesh Sharma – (Indian cricketer - senior group)</li>
                <li> Ritika Thaker – (International Badminton Player - senior group)</li>
                <li> Sanyog Bhagwat – (Under-19 cricketer- junior category)</li>
                <li> Sameeksha Chandak Basketball player - junior category)</li>
                <li>Maharashtra State Table Tennis Association secretary Adv. Ashutosh Potnis (Best organiser trophy)
                </li>
                <li> St. Ursula High School) (Best school respectively)</li>
                <li> Yashwantrao Chavan College of Engineering (YCCE) (Best College respectively)</li>
            </ul>
            <div _ngcontent-dhg-c30="" class="border-line-sm"></div>
            <div class="widget_title inner-title mt-3">
                <h4>SJAN-Raisoni Achievers Awards 2022 (23 NOVEMBER 2022)</h4>
            </div>
            <ul class="list-style list-style1">
                <li>Vaibhav Shrirame - (Best Senior Sportsman)</li>
                <li>Disha Kasat: (Best Senior Sportswoman) </li>
                <li>Aditya Yaul (Best Junior Sportsman)</li>
                <li>Jennifer Varghese (Best Junior Sportswoman)</li>
                <li>Mr. Haresh Vora (Best Sports Organiser) </li>
                <li>Centre Point School Trophy- TBRAN's Mundle English Medium School – (Best School)</li>
                <li>KC Bajaj Trophy for Service towards Sports - Taywade College, Koradi - (Best College)</li>
            </ul>
            <div _ngcontent-dhg-c30="" class="border-line-sm"></div>

            <div class="widget_title inner-title mt-3">
                <h4>WINNERS OF SJAN & RAISONI ACHIEVERS AWARD 2019 (29 DECEMBER 2019)</h4>
            </div>
            <ul class="list-style list-style1">
                <li>Rajneesh Gurbani GH Raisoni Trophy for best senior sportsman.</li>
                <li>Vaishnavi Bhale GH Raisoni Trophy for best senior sportswoman.</li>
                <li>Atharva Taide GH Raisoni Trophy for Best Junior Sportsperson.</li>
                <li>Rutuja Shend Baidyanath Trophy for best junior female player.</li>
                <li>Kamil Ansari Meeradevi Dasture Trophy for promoting sports.</li>
            </ul>

            <div _ngcontent-dhg-c30="" class="border-line-sm"></div>

            <div class="widget_title inner-title mt-3">
                <h4>WINNERS OF SJAN & RAISONI ACHIEVERS AWARD 2018 (24 NOVEMBER 2018)</h4>
            </div>
            <ul class="list-style list-style1">
                <li>Rajneesh Gurbani GH Raisoni Trophy for best senior sportsman.</li>
                <li>Vaishnavi Bhale GH Raisoni Trophy for best senior sportswoman.</li>
                <li>Atharva Taide GH Raisoni Trophy for Best Junior Sportsperson.</li>
                <li>Rutuja Shend Baidyanath Trophy for best junior female player.</li>
                <li>Kamil Ansari Meeradevi Dasture Trophy for promoting sports.</li>

            </ul>

            <div _ngcontent-dhg-c30="" class="border-line-sm"></div>

            <div class="widget_title inner-title mt-3">
                <h4>WINNERS OF SJAN & RAISONI ACHIEVERS AWARD 2017 (5 NOVEMBER 2017)</h4>
            </div>
            <ul class="list-style list-style1">
                <li>Indian woman cricketer Mona Meshram (GH Raisoni Trophy for best senior sportswoman),</li>
                <li>Vidarbha Ranji cricketer Lalit Yadav (GH Raisoni Trophy for best senior sportsman),</li>
                <li>Chess player Raunak Sadhwani (GH Raisoni Trophy for best junior sportsman),</li>
                <li>Shuttler Malvika Bansod (Baidyanath Trophy for best junior sportswoman)</li>
                <li>RS Mundle Dharampeth Arts and Commerce College (KC Bajaj Trophy for sports promotion)</li>
                <li>Swaminarayan School (Centre Point School Trophy for sports promotion).</li>
            </ul>

            <div _ngcontent-dhg-c30="" class="border-line-sm"></div>

            <div class="widget_title inner-title mt-3">
                <h4>WINNERS OF SJAN & RAISONI ACHIEVERS AWARDS 2016 (23 OCTOBER 2016)</h4>
            </div>
            <ul class="list-style list-style1">
                <li>Swapnil Dhopade</li>
                <li>Dhanashri Lakunwal</li>
                <li>Aditya Thakre</li>
                <li>Ritika Thaker</li>

            </ul>

            <div _ngcontent-dhg-c30="" class="border-line-sm"></div>

            <div class="widget_title inner-title mt-3">
                <h4>WINNERS OF SJAN & RAISONI ACHIEVERS AWARD 2015 (27 AUGUST 2015)</h4>
            </div>
            <ul class="list-style list-style1">
                <li>Vidarbha spinner Akshay Wakhare,</li>
                <li>volleyball player Jayashri Thakre,</li>
                <li> basketball player Yash Gainkar,</li>
                <li> chess prodigy Mrudul Dehankar</li>
                <li>sports organiser Sattar Ansari</li>
                <li> Katol’s Nabira Mahavidyalaya and Saraswati School for promoting the sports.</li>

            </ul>

            <div _ngcontent-dhg-c30="" class="border-line-sm"></div>

            <div class="widget_title inner-title mt-3">
                <h4>WINNERS OF SJAN & RAISONI ACHIEVERS AWARDS 2014 (7 SEPTEMBER 2014)</h4>
            </div>
            <ul class="list-style list-style1">
                <li>Batsman Of Vidarbha Faiz Fazal (GH Raisoni Trophy) ,</li>
                <li> Athlete Jyoti Chavan (GH Raisoni Trophy) ,</li>
                <li> Badminton Player Rohan Gurbani (GH Raisoni Trophy),</li>
                <li> Basketball Player Mugdha Amraotkar (Baidyanath Trophy)</li>
                <li> Ex-Hockey Player And Organiser Manish Gaur (Meeradevi Dasture Trophy)</li>
                <li>Nehru Vidyalaya, Hingna (Centre Point School Trophy),</li>
                <li>SK Porwal College (KC Bajaj Memorial Trophy)</li>

            </ul>

            <div _ngcontent-dhg-c30="" class="border-line-sm"></div>

            <div class="widget_title inner-title mt-3">
                <h4>WINNERS OF SJAN AND RAISONI ACHIEVERS AWARDS 2013 (29 AUGUST 2013)</h4>
            </div>
            <ul class="list-style list-style1">
                <li>Footballer Alwyn George (Best Senior Sportsman),</li>
                <li> Kho-Kho Player Deepali Sabane (Best Senior Sportswoman),</li>
                <li>Cricketer Siddhesh Nera</li>
                <li> Chess Wonderkid Divya Deshmukh (Best Junior Sportswoman)</li>
                <li>Khaparkheda’s Maharashtra Vidyalaya (Sports Promotion.)</li>
                <li>PWS College (Sports Promotion.)</li>

            </ul>
        </div>

        <div class="row  row-cols-1 row-cols-lg-2 justify-content-center align-items-center">
            <div class="col">
                <div class="feature-area ">
                    <div class="feature-wrap ">
                        <div class="single-feature">
                            <div class="title text-center">
                                <h3>Go To Gallery <i class="fa fa-arrow-right blink" aria-hidden="true"></i></h3>
                            </div>
                        </div>
                        <a href="sjan-award-gallery" class="feature-read-more text-center">
                            Read More
                            <i class="fa fa-arrow-right blink" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>


    </div>
</section>
